/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgDeploymentsBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.6 7.80028C12.6 9.12584 10.451 10.2004 7.8 10.2004C5.14903 10.2004 3 9.12584 3 7.80028M12.6 7.80028C12.6 6.47472 10.451 5.40015 7.8 5.40015C5.14903 5.40015 3 6.47472 3 7.80028M12.6 7.80028V11.4005M3 7.80028V11.4005M3 11.4005C3 12.7261 5.1488 13.8006 7.8 13.8006C10.4512 13.8006 12.6 12.7261 12.6 11.4005M3 11.4005V15.0007C3 16.3263 5.1488 17.4008 7.8 17.4008C10.4512 17.4008 12.6 16.3263 12.6 15.0007V11.4005M15 7.80026L12.6 10.2004M21 4.8001C21 5.79427 19.6569 6.6002 18 6.6002C16.3431 6.6002 15 5.79427 15 4.8001M21 4.8001C21 3.80593 19.6569 3 18 3C16.3431 3 15 3.80593 15 4.8001M21 4.8001V8.3993C21 9.39296 19.6568 10.1994 18 10.1994C16.3432 10.1994 15 9.39296 15 8.3993V4.8001M12.2728 15.8733L15 18.6006M21 15.6007C21 16.5949 19.6569 17.4008 18 17.4008C16.3431 17.4008 15 16.5949 15 15.6007M21 15.6007C21 14.6065 19.6569 13.8006 18 13.8006C16.3431 13.8006 15 14.6065 15 15.6007M21 15.6007V19.1999C21 20.1936 19.6568 21 18 21C16.3432 21 15 20.1936 15 19.1999V15.6007"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SvgDeployments = wrapIcon(SvgDeploymentsBase);
export default SvgDeployments;
